/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Radical(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M72,208a7.99963,7.99963,0,0,1-7.49072-5.19092l-48-128a8.00011,8.00011,0,0,1,14.98144-5.61816L72,177.21582l40.50928-108.0249A7.99963,7.99963,0,0,1,120,64H232a7.99977,7.99977,0,0,1,8,8V96a8,8,0,0,1-16,0V80H125.544L79.49072,202.80908A7.99963,7.99963,0,0,1,72,208Z" />
    </Svg>
  );
}

export default Radical;
